"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("./Logger");
function getLogLevelFromQueryParams() {
    if (typeof window !== 'undefined' && window.URLSearchParams) {
        var params = new URLSearchParams(location.search);
        return getLogLevel(params.get('debug'));
    }
    return Logger_1.LogLevel.NONE;
}
function getLogLevel(debug, trace) {
    if (debug === 'true') {
        return Logger_1.LogLevel.LOG;
    }
    if (debug) {
        return debug;
    }
    if (trace === 'true') {
        return Logger_1.LogLevel.TRACE;
    }
    return Logger_1.LogLevel.NONE;
}
function debugLog() {
    var messages = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        messages[_i] = arguments[_i];
    }
    var mode = getLogLevelFromQueryParams();
    switch (mode) {
        case Logger_1.LogLevel.LOG:
            console.log.apply(console, messages);
            break;
        case Logger_1.LogLevel.TRACE:
            console.trace.apply(console, messages);
            break;
        default:
    }
}
exports.debugLog = debugLog;
function getLogLevelFromControllerConfig(controllerConfig) {
    var logLevel = Logger_1.LogLevel.NONE;
    try {
        var _a = controllerConfig.wixCodeApi.location.query, debug = _a.debug, trace = _a.trace;
        logLevel = getLogLevel(debug, trace);
    }
    catch (e) { }
    return logLevel;
}
exports.getLogLevelFromControllerConfig = getLogLevelFromControllerConfig;
//# sourceMappingURL=debugLogger.js.map